import {datadogLogs} from '@datadog/browser-logs';
import {useEffect} from 'react';
import {formatVersionForDatadog} from 'utils/datadog-utils';
import Logger from 'utils/logger';
import * as EnvironmentConstants from '../constants/environment-constants';

const deployment = __DEPLOYMENT__;
const environment = deployment.includes('production') ? 'production' : deployment;

const isDatadogEnabled = __IS_DATADOG_ENABLED__;
const logger = new Logger('main');

export const useDatadogLogs = () => {
    useEffect(() => {
        if (!isDatadogEnabled) {
            return;
        }

        const initConfiguration = datadogLogs.getInitConfiguration();

        // Avoid reinitializing
        if (initConfiguration) {
            return;
        }

        const logsInitConfiguration = datadogLogs.getInitConfiguration();

        // Avoid reinitializing
        if (logsInitConfiguration) {
            return;
        }

        try {
            let ddClientToken: string;
            if (environment === 'production') {
                ddClientToken = EnvironmentConstants.DATADOG_PRODUCTION_SIMCAPTURE_CLOUD_CLIENT_TOKEN;
            } else {
                ddClientToken = EnvironmentConstants.DATADOG_DEVELOMENT_SIMCAPTURE_CLOUD_CLIENT_TOKEN;
            }

            datadogLogs.init({
                clientToken: ddClientToken,
                env: environment,
                site: 'datadoghq.com',
                service: EnvironmentConstants.SERVICE_CONSUMERS.SIMCAPTURE_CLOUD,
                version: formatVersionForDatadog(__VERSION__),
                sessionSampleRate: 100,
                forwardConsoleLogs: 'all',
            });
        } catch (err) {
            logger.error(`Failed to initialize Datadog SDK for environment: ${environment}`, err);
        }
    }, [isDatadogEnabled, environment]);
};
